import { useContext } from 'react';

import { FwPageStoreContext } from './FwPageStoreContext';

const useFwPageStore = () => useContext(FwPageStoreContext);

export { useFwPageStore };
